import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TypeReleveCompteur } from 'src/api/models';

@Component({
  selector: 'app-releve-compteur-type',
  templateUrl: './releve-compteur-type.component.html',
  styleUrls: ['./releve-compteur-type.component.css']
})
export class ReleveCompteurTypeComponent implements OnInit {

  @Input('id') public id: number;

  constructor(private translateService: TranslateService) { }

  ngOnInit(): void {
  }
  
  GetReleveCompteurType(t: TypeReleveCompteur) {
    if (t === undefined) {
      return '';
    } else {
      return this.translateService.instant('Entretien.RelevesCompteurs.TypesCompteurs.' + TypeReleveCompteur[t]);
    }
  } 
}
